import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Page from '~/components/page/page';
import Customer from '~/containers/customer/customer';

export class CustomerPage extends Component {
  render() {
    const customerId = this.props.match.params.customerId;
    return (
      <Page>
        <Customer id={customerId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(CustomerPage));



// WEBPACK FOOTER //
// ./src/pages/customer/customer.jsx